import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Space, Upload, Result, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import type { UploadProps } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useStepsForm } from "sunflower-antd";
import axios from "axios";

interface IModalProps {
  show: boolean;
  claimId: any;
  showModal: Function;
  handleAdd: Function;
}

const PaidClaimModal: React.FC<IModalProps> = ({
  show,
  claimId,
  showModal,
  handleAdd,
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<any>();
  const [imageUrl, setImageUrl] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const convertFileToBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        resolve(event?.target?.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  };

  const props: UploadProps = {
    name: "file",
    customRequest: async ({ file, onSuccess, onError }) => {
      try {
        const base64 = await convertFileToBase64(file);
        const accessToken = localStorage.getItem("AccessToken");
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/v1/document/image`,
          {
            base64: base64,
          },
          {
            headers: {
              AccessToken: accessToken ? accessToken : "",
            },
          }
        );
        if (onSuccess) {
          setImageUrl(response.data.data);
          onSuccess(response.data);
        }
      } catch (error) {
        if (onError) {
          onError(new Error("Upload failed"));
        }
      }
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
      setFormData({ name: info.file.name });
    },
  };

  //   useEffect(() => {
  //     getMemberApi(String(memberId))
  //       .then((res: any) => {
  //         form.setFieldsValue({
  //           Amount: res.data.Policy.Product.PolicyPremium,
  //         });
  //       })
  //       .catch((err: any) => {
  //         console.log(err);
  //       });
  //   }, []);

  const handleModal = () => {
    showModal();
    gotoStep(0);
    form.resetFields();
  };

  const {
    form,
    current,
    gotoStep,
    stepsProps,
    formProps,
    submit,
    formLoading,
  } = useStepsForm({
    isBackValidate: false,
    async submit(values: any) {
      setLoading(true);

      const response = await handleAdd(
        {
          ...values,
          Document: { Name: formData, Link: imageUrl },
        },
        claimId
      );

      if (response.success) {
        setLoading(false);
        return true;
      }
      setErrorMsg(response.message);
      setLoading(false);
      return false;
    },
    total: 2,
  });

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 8 },
  };

  const tailLayout = {
    labelCol: { span: 0 },
    wrapperCol: { offset: 8, span: 8 },
  };

  const formList: any = [
    <>
      <Form.Item name="Notes" label="Notes">
        <TextArea size="large" id="Notes" placeholder="Notes" />
      </Form.Item>
      <Form.Item
        name="Document"
        label="Document"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Upload
          listType="picture"
          //   defaultFileList={[
          //     {
          //       uid: "-1",
          //       name: "Company_Logo",
          //       status: "done",
          //       url: formData?.CompanyLogo,
          //       thumbUrl: formData?.CompanyLogo,
          //     },
          //   ]}
          {...props}
        >
          <Button icon={<UploadOutlined />}>Click to Upload</Button>
        </Upload>
      </Form.Item>

      <Form.Item {...tailLayout}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Button
            loading={loading}
            style={{ marginBottom: 10 }}
            block
            size="large"
            onClick={() => {
              submit().then((result: any) => {
                if (result) {
                  gotoStep(current + 1);
                } else if (!result) {
                  gotoStep(current + 2);
                }
              });
            }}
          >
            Submit
          </Button>
        </Space>
      </Form.Item>
    </>,
  ];

  return (
    <Modal
      title="Paid Claim"
      open={show}
      onOk={handleModal}
      onCancel={handleModal}
      width={600}
      footer={null}
    >
      {/* Steps Form */}
      <div>
        <div style={{ marginTop: 60 }}>
          <Form {...layout} {...formProps} style={{ maxWidth: 900 }}>
            {formList[current]}
          </Form>

          {current === 1 && (
            <Result status="success" title="Successfully submitted.">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}

          {current === 2 && (
            <Result status="error" title="Error occurred, please try again.">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default PaidClaimModal;
